/**
 * Custom scripts for understrap child theme.
 */

import customBS5Lightbox from "./bs5-lightbox-gutenberg";
import A11yBar from "./a11y-bar";
import skipLinkFocusFix from "./skip-link-focus-fix";


customBS5Lightbox();
skipLinkFocusFix();

export {
    A11yBar
}

document.addEventListener("DOMContentLoaded", (event) => {
    
    let items = document.querySelectorAll('.carousel .carousel-item')

            items.forEach((el) => {
                var minPerSlide = 2
                if (window.matchMedia("(min-width: 992px)").matches) {
                    var minPerSlide = 4
                }
                let next = el.nextElementSibling
                for (var i=1; i<minPerSlide; i++) {
                    if (!next) {
                // wrap carousel by using first child
                next = items[0]
            }
            let cloneChild = next.cloneNode(true)
            el.appendChild(cloneChild.children[0])
            next = next.nextElementSibling
        }
    })

    // Affichage du bouton de retour en haut de page
    var btn = document.getElementById('btn-to-top');
    let lastKnownScrollPosition = 0;
	window.addEventListener('scroll', (event) => {
        lastKnownScrollPosition = window.scrollY;
        if (lastKnownScrollPosition > 300) {
			btn.classList.add('show');
		} else {
			btn.classList.remove('show');
		}
    });
	btn.onclick = function (e) {
		e.preventDefault();
		document.documentElement.scrollTop = 0;
	};

    // Vérifie si la largeur de l'écran est supérieure à 768 pixels
    /*if (window.matchMedia('(min-width: 768px)').matches) {
        disableButton();
    }*/

});

// Fonction pour désactiver le bouton
/*function disableButton() {
    var button = document.getElementById('btn--filter-event');
    button.disabled = true;
}*/